import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { CredentialsEntity } from '../models/credentials';

type UserCredentialsStoreState = {
  data: CredentialsEntity[];
};

const initialState: UserCredentialsStoreState = {
  data: [],
};

export const userCredentialsSlice = createSlice({
  name: 'userCredentials',
  initialState,
  reducers: {
    addUserCredentials: (state, action: PayloadAction<CredentialsEntity>) => {
      state.data.push(action.payload);
    },
    setUserCredentials: (state, action: PayloadAction<CredentialsEntity>) => {
      state.data = [action.payload];
    },
    resetUserCredentials: (state) => {
      state.data = [];
    },
  },
});

export const { addUserCredentials, setUserCredentials, resetUserCredentials } =
  userCredentialsSlice.actions;
